module.exports = __webpack_public_path__ + "img/road_map_mobile.893562ac.png";